(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/result-overview.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/result-overview.js');

'use strict';

svs.game_results.views.ResultOverview = Marionette.View.extend({
  className: 'game-results js-game-results-overview',
  template(data) {
    return svs.game_results.templates.result_overview(data);
  },
  regions: {
    calendar: '#calendar',
    bigStatRegion: '#bigStatRegion',
    gameResult: '#gameResult',
    sportkryssResult: '#sportkryssResult'
  },
  initialize() {
    svs.components.header.triggerOnHeaderVisibilityChange(true, ['xs', 'sm']);
  },
  onRender() {
    const gameResultModel = this.model;
    const self = this;
    svs.game_results.models.calendar = new svs.game_results.models.Calendar({
      product: this.model.get('productName'),
      startDate: this.model.get('date') 
    });
    svs.game_results.models.calendar.on('change:drawNumber', e => {
      gameResultModel.getResult(e.changed.drawNumber);
      if (!svs.core.detect.formfactor.mobile() && self.getRegion('bigStatRegion').$el.children().length) {
        self.getRegion('bigStatRegion').empty({
          emptyOptions: {
            skipAnim: true
          }
        });
        svs.game_results.views.bigNavView = null;
      }
    });
    svs.game_results.models.calendar.on('change:date', e => {
      if (gameResultModel.updateDate) {
        gameResultModel.updateDate(e.get('date'));
      }
    });
    this.showChildView('calendar', new svs.game_results.views.Calendar({
      model: svs.game_results.models.calendar
    }));
    switch (this.model.get('productName').toLowerCase()) {
      case 'stryktipset':
      case 'maltipset':
        this.gameResultView = new svs.game_results.views.Tipset({
          model: this.model
        });
        this.showChildView('gameResult', this.gameResultView);
        this.showChildView('sportkryssResult', new svs.game_results.views.Sportkryss({
          model: this.model
        }));
        break;
      case 'europatipset':
      case 'topptipset':
        this.gameResultView = new svs.game_results.views.Tipset({
          model: this.model
        });
        this.showChildView('gameResult', this.gameResultView);
        break;
      case 'bomben':
      case 'challenge':
      case 'powerplay':
        this.showChildView('gameResult', new svs.game_results.views.Rounds({
          model: this.model
        }));
        break;
      case 'matchen':
        this.showChildView('gameResult', new svs.game_results.views.Matchen({
          model: this.model
        }));
        break;
      default:
    }
  },
  onDomRefresh() {
    $('html,body').animate({
      scrollTop: 0
    });
    $('.game-results-calendar').css('width', $('#gameResult').width());
  },
  onAttach() {
    if (this.model && this.model.get('product') === 'challenge' || this.model.get('product') === 'powerplay' || this.model.get('product') === 'bomben') {
      this.model.trigger('change');
    }
    svs.core.detect.orientation.on('change', () => {
      this.updateDimensions();
    });
    if (!svs.core.detect.formfactor.mobile()) {
      this.updateDimensions();
      _.defer(() => {
        window.onresize = () => {
          $('.game-results-calendar').css('width', $('#gameResult').width());
          this.updateDimensions();
        };
      });
    }
  },
  updateDimensions() {
    if (!svs.core.detect.formfactor.mobile() && this.model.get('useStatistics')) {
      const availableHeight = svs.game_results.utils.calcAvailableHeight();
      $('#coupon').css({
        height: "".concat(availableHeight - 12, "px"),
        'overflow-y': 'auto',
        '-webkit-overflow-scrolling': 'touch'
      });
      $('#bigStatRegion').css('height', availableHeight);
    }
  }
});

 })(window);